export default __webpack_public_path__ + "static/media/jrc_logo.13faa9de.svg";